<template lang="pug">
  div
    component(v-if="nestedSkip" v-bind="record" :is="nestedSkip")
    div.skip(v-else)
      div.skip-header
        img(src="/img/warning.svg")
        h1 Предупреждение!
      Box
        p Уважаемый акционер, обращаем внимание, что&nbsp;если вы&nbsp;пропускаете этот шаг, то&nbsp;ожидание своей очереди в&nbsp;офисе может быть увеличено до&nbsp;30 минут.
        p.bold Хотите оплатить сейчас?
        .form__button
          Button(
            :action="cardPay"
            :classes="['is-large']"
            label="Оплатить сейчас"
          )
          Button(
            :action="skip"
            :classes="['is-large', 'not-bordered']"
            label="Пропустить"
          )
</template>

<script>
import Box from "@/components/ui/Box.vue";
import Button from "@/components/Button.vue";
import api from "@/api/reception";
import { mapGetters } from "vuex";

export default {
  components: {
    Box,
    Button
  },
  data() {
    return {
      nestedSkip: ""
    };
  },
  computed: {
    ...mapGetters("submit", ["submits"]),
    ...mapGetters("form", ["forms"]),
    orderId() {
      return this.submits.form && this.submits.form.data
        ? this.submits.form.data.order_id
        : "";
    }
  },
  methods: {
    skip() {
      let component = "";
      if (
        this.submits.record &&
        this.submits.record.data &&
        this.submits.record.data.completed
      ) {
        component = "PayInOfficeWithRecord";
      } else {
        component = "PayInOfficeWithoutRecord";
      }
      this.nestedSkip = () => import(`@/components/skip/${component}`);
    },
    cardPay() {
      api.register(this.orderId).then(result => {
        if (this.forms.record && this.forms.record.data) {
          const recordData = { ...this.forms.record.data };
          let paymentData = {
            order_number: this.submits.form.data.order_id
          };

          if (recordData && recordData.visit_date) {
            paymentData.visit_date = recordData.visit_date;
          }

          if (recordData && recordData.visit_time) {
            paymentData.visit_time = recordData.visit_time;
          }

          if (recordData.filial && recordData.filial.address) {
            paymentData.address = recordData.filial.address;
          }

          if (recordData.filial && recordData.filial.coordinates) {
            paymentData.coordinates = recordData.filial.coordinates;
          }

          sessionStorage.setItem("payment_data", JSON.stringify(paymentData));
        }

        if (result.data && result.data.redirect) {
          window.location.href = result.data.redirect;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.skip {
  &-header {
    img {
      margin: 0 auto;
      padding-bottom: 15px;
    }
    h1 {
      color: #fff;
      text-align: center;
      padding-bottom: 30px;
    }
  }

  .box {
    display: block;
    min-height: auto;

    p {
      font-size: 22px;
      line-height: 33px;
      color: #333;
      text-align: center;

      &.bold {
        font-weight: 700;
      }
    }

    .form__button {
      padding-top: 30px;

      button {
        margin: 0 auto;
      }
    }
  }
}
</style>
